var config = {
  scheme: 'release',
  env: {
    alpha: {
      prefix: ''
    },
    beta: {
      prefix: '/admin',
      apiPath: '/apiPath',
      basicUrl: 'http://dev.lvyuetravel.com:8080',
      aihuazhuUrl: 'http://test.www.aihuazhu.com',
      imagesUrl: 'http://test.static.lvyuetravel.com/www/zh/static/images/',
      senCondjs:'http://dev.lvyuetravel.com:8080/static/sensorsdata.min.js',
      senCond:'https://shence.lvyuetravel.com/sa?project=default'
    },
    devx: {
      prefix: '',
      apiPath: '',
      basicUrl: 'http://dev.www.lvyuetravel.com',
      aihuazhuUrl: 'http://dev.www.aihuazhu.com',
      imagesUrl: 'http://dev.static.lvyuetravel.com/www/zh/static/images/',
      senCondjs:'http://dev.static.lvyuetravel.com/www/zh/static/sensorsdata.min.js',
      senCond:'https://shence.lvyuetravel.com/sa?project=default'
    },
    test: {
      prefix: '',
      apiPath: '',
      basicUrl: 'http://test.www.lvyuetravel.com',
      aihuazhuUrl: 'http://test.www.aihuazhu.com',
      imagesUrl: 'http://test.static.lvyuetravel.com/www/zh/static/images/',
      senCondjs:'http://test.static.lvyuetravel.com/www/zh/static/sensorsdata.min.js',
      senCond:'https://shence.lvyuetravel.com/sa?project=default'
    },
    integrate: {
      prefix: '',
      apiPath: '',
      basicUrl: 'http://www.integrate.lvyuetravel.com',
      aihuazhuUrl: 'http://www.integrate.aihuazhu.com',
      imagesUrl: 'http://static.integrate.lvyuetravel.com/www/zh/static/images/',
      senCondjs:'http://static.integrate.lvyuetravel.com/www/zh/static/sensorsdata.min.js',
      senCond:'https://shence.lvyuetravel.com/sa?project=default'
    },
    production: {
      prefix: '',
      apiPath: '',
      basicUrl: 'https://www.lvyuetravel.com',
      aihuazhuUrl: 'https://www.aihuazhu.com',
      imagesUrl: 'https://static.lvyuetravel.com/www/zh/static/images/',
      senCondjs:'https://static.lvyuetravel.com/www/zh/static/sensorsdata.min.js',
      senCond:'https://shence.lvyuetravel.com/sa?project=production'
    }
  },
  domains: {
    urlStatic: '',
    loginSite: 'http://test.www.lvyuetravel.com',
  }
};

// 环境切换
if (process.env.NODE_PMS == 'dev') {
  config.scheme = 'beta';
}else if(process.env.NODE_PMS == 'devx') {
  config.scheme = 'devx';
}else if(process.env.NODE_PMS == 'test') {
  config.scheme = 'test';
}else if(process.env.NODE_PMS == 'integrate') {
  config.scheme = 'integrate';
}else if(process.env.NODE_PMS == 'production') {
  config.scheme = 'production';
}
module.exports = config;



// WEBPACK FOOTER //
// ./src/config/config.js